import { render, staticRenderFns } from "./InstallerDetails.vue?vue&type=template&id=70c623d3"
import script from "./InstallerDetails.vue?vue&type=script&lang=js"
export * from "./InstallerDetails.vue?vue&type=script&lang=js"
import style0 from "./InstallerDetails.vue?vue&type=style&index=0&id=70c623d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
